export default __webpack_public_path__ + "static/media/Technical.5ee09e2d.svg";